export default __webpack_public_path__ + "462505da69a17506d4ab9b77ec267822.png";